/**
 * Skeleton for tutor dashboard: assignment cards grid + students table area.
 */
import { AdminTableSkeleton } from '@/components/skeletons/AdminTableSkeleton';

function AssignmentCardSkeleton() {
  return (
    <div className="rounded-xl border border-border bg-card p-6 flex items-center gap-4 animate-pulse">
      <div className="w-12 h-12 rounded-lg bg-muted shrink-0" />
      <div className="min-w-0 flex-1 space-y-2">
        <div className="h-4 w-3/4 bg-muted rounded" />
        <div className="h-3 w-1/2 bg-muted rounded" />
      </div>
      <div className="w-5 h-5 rounded bg-muted shrink-0" />
    </div>
  );
}

export function TutorDashboardSkeleton() {
  return (
    <div className="min-h-screen bg-secondary/30">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-8 animate-pulse">
          <div className="w-12 h-12 rounded-xl bg-muted" />
          <div className="space-y-2">
            <div className="h-7 w-48 bg-muted rounded" />
            <div className="h-4 w-72 bg-muted rounded" />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          {[1, 2, 3, 4].map((i) => (
            <AssignmentCardSkeleton key={i} />
          ))}
        </div>
        <div className="rounded-2xl border border-border bg-card overflow-hidden">
          <div className="flex border-b border-border">
            <div className="h-12 w-24 bg-muted/50 mx-2 rounded mt-2" />
            <div className="h-12 w-24 bg-muted/30 mx-2 rounded mt-2" />
          </div>
          <div className="p-6">
            <AdminTableSkeleton rows={5} cols={7} />
          </div>
        </div>
      </div>
    </div>
  );
}
